import React from "react";
import { Helmet } from "react-helmet";
import { ThemeProvider } from "styled-components";

import { Toasted } from "components";

import * as Modals from "../components/Modals";

import { default as GlobalStyles } from "./global";

interface IProviderProps {
  children: React.ReactNode;
}

const Provider: React.FC<IProviderProps> = (props) => {
  return (
    <ThemeProvider
      theme={{
        mode: "light",
        layout: "default",
      }}
    >
      <Helmet>
        <meta name="theme-color" content={"#FFFFFF"} />
      </Helmet>

      <GlobalStyles baseFontSize={16} />

      <Modals.Promised.Provider />

      <Toasted />

      {props.children}
    </ThemeProvider>
  );
};

export default Provider;
